import { Container } from '@mui/material';

import PagePlaceholder from '../../components/PagePlaceholder';

export default function AccountPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <PagePlaceholder title="Mi cuenta" description="Datos de la cuenta del cliente autenticado." />
    </Container>
  );
}
